import React from 'react';
import Select from '../../../components/ui/Select';

const AnalyticsFilters = ({
  dateRange,
  department,
  onDateRangeChange,
  onDepartmentChange
}) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Date Range Filter */}
        <div>
          <label className="text-xs text-muted-foreground mb-1 block">
            Período de Análise
          </label>
          <Select value={dateRange} onValueChange={onDateRangeChange}>
            <option value="today">Hoje</option>
            <option value="week">Esta Semana</option>
            <option value="month">Este Mês</option>
            <option value="quarter">Este Trimestre</option>
            <option value="year">Este Ano</option>
            <option value="custom">Personalizado</option>
          </Select>
        </div>

        {/* Department Filter */}
        <div>
          <label className="text-xs text-muted-foreground mb-1 block">
            Departamento
          </label>
          <Select value={department} onValueChange={onDepartmentChange}>
            <option value="all">Todos os Departamentos</option>
            <option value="technical">Técnico</option>
            <option value="consulting">Consultoria</option>
            <option value="support">Suporte</option>
            <option value="development">Desenvolvimento</option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsFilters;